import { SxProps, Theme } from '@mui/material/styles';
import { OptionType } from 'src/components/Select';
import getStatusColor from './getStatusColor';

export const BOOL_LIKE_OPTIONS = ['boolNumberCodes', 'scanImeiSnCodes', 'batteryTypeCodes'] as const;

export type BoolLikeSelectOptionType = (typeof BOOL_LIKE_OPTIONS)[number];

export const isBoolLikeSelectOption = (selectOption?: string): selectOption is BoolLikeSelectOptionType =>
    !!selectOption && (BOOL_LIKE_OPTIONS as readonly string[]).includes(selectOption);

export const getBooleanOptionStyle = (option: OptionType): SxProps<Theme> | null => {
    const isTrue = option.value === 1 || option.value === true || String(option.value) === '1';
    const color = isTrue ? '#4caf50' : '#f44336';
    return { color };
};

const colorOptionFce = (option: OptionType): SxProps<Theme> | null => {
    if (option.color) {
        if (option.color.startsWith('#')) {
            return { color: option.color };
        }
        return { color: getStatusColor(option.color) };
    }
    return null;
};

export const applicationMessageColorOptionFce = (option: OptionType): SxProps<Theme> | null => {
    if (option.color) {
        return { color: option.color };
    }
    return null;
};

export const normalizeBoolNumberValue = (value: unknown): number | '' => {
    if (value === 1 || value === true || value === '1') {
        return 1;
    }
    if (value === 0 || value === false || value === '0') {
        return 0;
    }
    const upper = String(value ?? '').toUpperCase();
    if (upper === 'ANO' || upper === 'YES') {
        return 1;
    }
    if (upper === 'NE' || upper === 'NO') {
        return 0;
    }
    return '';
};

export default colorOptionFce;
